import { render, staticRenderFns } from "./AddInvoiceInfoComponent.vue?vue&type=template&id=2952923f&"
import script from "./AddInvoiceInfoComponent.vue?vue&type=script&lang=js&"
export * from "./AddInvoiceInfoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports